import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
const COACH_PHOTO = 'https://cdn.magicpatterns.com/uploads/6xgB1yXGurLJYx3sbQsL1h/ChatGPT_Image_11_sept_2026,_15_45_35.webp';
const stats = [{
  valor: '12.000+',
  label: 'Mujeres desinflamadas'
}, {
  valor: '245',
  label: 'Recetas exclusivas'
}, {
  valor: '4.9/5',
  label: 'Rating promedio'
}];
export function CoachSection() {
  return <section className="w-full bg-gradient-to-b from-mint to-mint-dark px-6 py-20 text-center text-white sm:px-10" data-id="element-32" data-mp="1adhn4yfywlut">
      <div className="mx-auto flex max-w-3xl flex-col items-center" data-id="element-33" data-mp="1fb1b4q2gwczy">
        <img src={COACH_PHOTO} alt="Dra. Marta González, nutricionista clínica registrada" className="h-[160px] w-[160px] rounded-full border-4 border-white object-cover object-center shadow-xl sm:h-[180px] sm:w-[180px]" data-id="element-34" data-mp="1kbf9thi6ialb" />
        <h2 className="mt-6 font-heading text-2xl font-bold sm:text-3xl" data-id="element-35" data-mp="3m4d5rm795jah">Dra. Marta González</h2>
        <p className="mt-2 flex items-center justify-center gap-1.5 text-base" data-id="element-36" data-mp="3r1vgni4ty8l4">
          <GraduationCapIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="foen4p1mbgby" /> Nutricionista Clínica Registrada
        </p>
        <p className="mt-1 text-base" data-id="element-38" data-mp="avlis2a2aa0e">15+ años de experiencia en nutrición antiinflamatoria</p>

        <p className="mt-8 max-w-2xl text-[15px] leading-relaxed text-white/95" data-id="element-39" data-mp="5yd2664kae19">
          He ayudado a más de 12.000 mujeres a desinflamarse sin dietas restrictivas ni sufrimiento.
          <br data-id="element-40" data-mp="yl642rtotjcu" />
          <br data-id="element-41" data-mp="ylz479y55am0" />
          Creo que la comida debe ser deliciosa y saludable. Por eso diseñé este sistema: recetas que te hacen sentir mejor
          realmente, no promesas vacías.
        </p>

        <div className="mt-10 grid w-full grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-42" data-mp="omq9ufzd5tz4">
          {stats.map(stat => <div key={stat.label} className="rounded-xl bg-white/15 px-4 py-6" data-id="element-43" data-mp="kmg85filtpq2">
              <p className="font-heading text-2xl font-bold" data-id="element-44" data-mp="39fbqisf1colj">{stat.valor}</p>
              <p className="mt-1 text-sm text-white/90" data-id="element-45" data-mp="35cp08vy0jbqg">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}